export const i18nRoot = "space_access_management";
export const NOT_FOUND = -1;
export const defaultAction = (action: any) => {
  action();
};
